import React from "react";
import DataTableActionMenu from "../Elements/DataTable/DataTableActionMenu";
import FieldTypesEnum from "../Enums/FieldTypesEnum";
import TabListTableCellWidthEnum from "../Enums/TabListTableCellWidthEnum";
import JsxHelper from "../Helpers/JsxHelper";

export default class CaspianXxApiQueryItem {
  constructor(item) {
    if (item === undefined) {
      this.CaspianXextraApiQueryId = "";
      this.QueryText = "";
      this.TargetType = "";
      this.Frequency = "";
      this.StartDate = "";
      this.EndDate = "";
      this.IsActive = "true";
      this.LastSentOn = "";
      this.CreatedOn = "";
      this.CreatedBy = "";
      this.ModifiedOn = "";
      this.ModifiedBy = "";
    } else {
      this.initialize(item);
    }
  }

  async initialize(item) {
    this.CaspianXextraApiQueryId = item.caspianXextraApiQueryId;
    this.QueryText = item.queryText;
    this.TargetType = item.targetType;
    this.Frequency = item.frequency;
    this.StartDate = item.startDate;
    this.EndDate = item.endDate;
    this.IsActive = item.isActive;
    this.LastSentOn = item.lastSentOn;
    this.CreatedOn = item.createdOn;
    this.CreatedBy = item.createdBy;
    this.ModifiedOn = item.modifiedOn;
    this.ModifiedBy = item.modifiedBy;
  }

  static NameOfTheIdField() {
    return "CaspianXextraApiQueryId";
  }
  static nameOfTheItemDetailList() {
    return "CaspianXxApiQuery";
  }

  static MoneyFields = [];

  static Currency() {
    return "";
  }

  static MoneyFieldsSecondary = [];

  static CurrencySecondary() {
    return "";
  }

  static DateFields = ["StartDate", "EndDate", "LastSentOn", "CreatedOn", "ModifiedOn"];

  static BoolFields = ["IsActive"];

  static FieldsToShowInListTable = [
    {
      tabName: "Query",
      tabLabel: "Query",
      icon: "fa-solid fa-users",
      data: [
        { name: "CaspianXextraApiQueryId", label: "CaspianXextraApiQueryId" },
        { name: "TargetType", label: "Target Type" },
        { name: "Frequency", label: "Frequency" },
        { name: "QueryText", label: "Query Template Text", width: TabListTableCellWidthEnum.TwoLines, className: "text-left" },
        { name: "StartDate", label: "Start Date" },
        { name: "EndDate", label: "End Date" },
        { name: "IsActive", label: "Is Active" },
        { name: "LastSentOn", label: "Last Sent On" },
        { name: "CreatedOn", label: "Created On" },
        { name: "CreatedBy", label: "Created By" },
        { name: "ModifiedOn", label: "Modified On" },
        { name: "ModifiedBy", label: "Modified By" },
      ],
    },
  ];

  //Meaning of data field:
  //   if type is FieldTypesEnum.DataFieldWithDetails then it is the name of the ID field
  //   if type is FieldTypesEnum.PureDataField then it is the name of the field to show or it is a function
  //			and the field shows the result of this function
  //   if type is FieldTypesEnum.FunctionField then it is the function which will be called by clicking on the labeltext in the cell.
  static FieldsToShowInDataTable() {
    return [
      { label: "Id", orderById: "CaspianXextraApiQueryId", data: "CaspianXextraApiQueryId", type: FieldTypesEnum.DataFieldWithDetails, minWidth: 50 },
      { label: "Target Type", orderById: "TargetType", data: "TargetType" },
      { label: "Frequency", orderById: "Frequency", data: "Frequency", minWidth: 50 },
      { label: "Start Date", orderById: "StartDate", data: "StartDate", minWidth: 50 },
      { label: "End Date", orderById: "EndDate", data: "EndDate", minWidth: 50 },
      { label: "Last Sent On", orderById: "LastSentOn", data: "LastSentOn", type: FieldTypesEnum.Email, minWidth: 50 },
      { label: "Is Active", orderById: "IsActive", data: (item) => JsxHelper.YesNo(item.IsActive) },
      { label: "Actions", orderById: "", data: CaspianXxApiQueryItem.getActionsContent, type: FieldTypesEnum.ActionButton },
    ];
  }

  static getActionsContent(item) {
    return (
      <DataTableActionMenu
        options={[
          {
            iconName: "fa-solid fa-edit",
            onClick: () => CaspianXxApiQueryItem.editFunction(item.CaspianXextraApiQueryId, item),
            text: "Edit",
            tooltipText: "Edit",
          },
        ]}
      />
    );
  }

  static editFunction(id, item) {
    //this is just a placeholder
  }
}
